import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Close } from '@material-ui/icons'
import { Label, TextField, CleanButton } from '../default'
import { Box, Grid, IconButton, Modal, Paper, Tooltip, withStyles } from '@material-ui/core'
import { connect, useDispatch } from 'react-redux'

import { Loader, Alert, PrimaryButton } from '../../components/default'
import { acGetIssTax, acPutIssTax } from '../../class/actions'


function UpdateISSModal({
  classes, open, onClose,
  fetchError, loadingGetIssTax, loadingPutIssTax
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [value, setValue] = useState('')
  const [valueError, setValueError] = useState('')
  const [error, setError] = useState(null)

  useEffect(() => {
    dispatch(acGetIssTax()).then(response => {
      if (response.issTax) {
        setValue(parseFloat(response.issTax))
      }
    })
  }, [dispatch])

  const updateIssTax = () => {
    if (valueError) {
      return
    }

    setValueError(null)

    dispatch(acPutIssTax(value))
      .then(() => onClose())
      .catch(err => setError(err))
  }

  const validateValue = value => {
    if (isNaN(value)) {
      setValueError(t('modals.financial.config.invalidValue'))
      setValue(value)
      return
    }

    const numericValue = parseFloat(value)

    if (numericValue > 100) {
      setValueError(t('modals.financial.config.invalidValue'))
      setValue(numericValue)
      return
    }

    setValueError(null)
    setValue(numericValue)
  }

  return (
    <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0, overflowY: 'scroll' }}>
      <Paper
        square={true}
        className={classes.root + ' ' + classes.modalDiv}
      >
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Grid container spacing={2} className={classes.grid}>
            <Grid item xs={8}>
              <Label v='h6'>
                {t('modals.financial.config.issTax.title')}
              </Label>
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'right', padding: 0 }}>
              <Tooltip title={t('default.close')}>
                <IconButton onClick={onClose}>
                  <Close />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item xs={4}>
              <TextField
                light
                variant='filled'
                type="number"
                label={t('modals.financial.config.issTax.fieldLabel')}
                value={value}
                onChange={e => validateValue(e.target.value)}
                error={valueError ? true : false}
                helperText={valueError ? valueError : null}
                style={{ width: '100%' }} />
            </Grid>
          </Grid>
        </Box>

        <div>
          <div style={{ marginTop: '15px' }}>
            <Grid container style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <CleanButton onClick={onClose} style={{ marginRight: '15px' }}>
                {t('default.cancel')}
              </CleanButton>
              <PrimaryButton onClick={updateIssTax}>
                {
                  (loadingGetIssTax || loadingPutIssTax) ? (
                    <Loader />
                  ) : (
                    <div>
                      {t('modals.financial.config.issTax.update')}
                    </div>
                  )
                }
              </PrimaryButton>
            </Grid>
          </div>
          <div style={{ marginTop: '15px' }}>
            {
              (fetchError) ? (
                <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={fetchError.description ? fetchError.description : t('modals.financial.config.issTax.unknownFetchError')} />
              )
                : valueError ?
                  <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={valueError} /> :
                  error ?
                    <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={error.description ? error.description : t('modals.financial.config.issTax.unknownFetchError')} /> : null
            }
          </div>
        </div>
      </Paper>
    </Modal >
  )
}

UpdateISSModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  close: PropTypes.func
}

UpdateISSModal.defaultProps = {
  open: false,
  onClose: () => true,
  close: () => true
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    padding: theme.spacing(2),
  },
  grid: {
    display: 'flex',
    flex: 1
  },
  modalDiv: {
    [theme.breakpoints.up('md')]: {
      width: '35%'
    },
    width: '100%',
    top: '10%',
    left: '50%',
    transform: 'translate(-50%, -10%)',
  }
})

const mapStateToProps = ({ ReducerFinancial }) => ({
  loadingGetIssTax: ReducerFinancial.loadingGetIssTax,
  loadingPutIssTax: ReducerFinancial.loadingGPutIssTax,
  fetchError: ReducerFinancial.errorGetIssTax,
  issTax: ReducerFinancial.issTax
})

export default connect(mapStateToProps)(withStyles(styles)(UpdateISSModal))